<template>
  <img
    :width="imgWidth"
    :height="imgHeight"
    :src="src"
    role="button"
    :preview="group"
    :preview-text="previewText"
    :onerror="store.state.commonStore.noPic"
  />
</template>

<script>
import store from "@/store/store";
export default {
  name: "FImage",
  components: {},
  props: {
    // 图片源
    src: {
      type: String,
      required: true,
    },
    // 缩略图显示宽度
    width: {
      type: String,
      default: "",
    },
    // 缩略图显示高度
    height: {
      type: String,
      default: "",
    },
    // 图片组，同组内的图片可以左右切换
    group: {
      type: String,
      default: function () {
        return (
          "image-" + +new Date() + ((Math.random() * 1000).toFixed(0) + "")
        );
      },
    },
    // 预览图片时，底部的文字描述
    previewText: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      store: store,
    };
  },
  computed: {
    imgWidth() {
      if (this.width !== "") {
        return this.width;
      } else {
        if (this.height !== "") {
          return "auto";
        } else {
          return "40px";
        }
      }
    },
    imgHeight() {
      if (this.height !== "") {
        return this.height;
      } else {
        return "auto";
      }
    },
  },
  methods: {},
};
</script>
